import React from 'react'

export default function Size() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-6 mt-2 sm:px-6 sm:py-1 lg:max-w-7xl lg:px-8 xl:max-w-screen-xl 2xl:max-w-screen-2xl">

      <span >CHỌN SIZE CHO ÁO NAM</span>
      <div className='md:pl-10 xl:pl-20 pb-10'>
        <div class="flex flex-col max-w-2xl">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div class="overflow-hidden">
                <table class="min-w-full text-center text-sm font-light">
                  <thead
                    class="border-b bg-neutral-50 font-medium dark:border-neutral-500 dark:text-neutral-800">
                    <tr>
                      <th scope="col" class=" px-6 py-4">Size</th>
                      <th scope="col" class=" px-6 py-4">Chiều cao(cm)</th>
                      <th scope="col" class=" px-6 py-4">Cân nặng(kg)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">M</td>
                      <td class="whitespace-nowrap  px-6 py-4">160 - 168</td>
                      <td class="whitespace-nowrap  px-6 py-4">50 - 62</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">L</td>
                      <td class="whitespace-nowrap  px-6 py-4">169 - 173</td>
                      <td class="whitespace-nowrap  px-6 py-4">63 - 68</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XL</td>
                      <td class="whitespace-nowrap  px-6 py-4">171 - 174</td>
                      <td class="whitespace-nowrap  px-6 py-4">68 - 73</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XXL</td>
                      <td class="whitespace-nowrap  px-6 py-4">173 - 177</td>
                      <td class="whitespace-nowrap  px-6 py-4">74 - 80</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XXXL</td>
                      <td class="whitespace-nowrap  px-6 py-4">175 - 180</td>
                      <td class="whitespace-nowrap  px-6 py-4">81 - 90</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span >CHỌN SIZE CHO QUẦN NAM</span>
      <div className=' md:pl-10 xl:pl-20  pb-10'>
        <div class="flex flex-col max-w-2xl">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div class="overflow-hidden">
                <table class="min-w-full text-center text-sm font-light">
                  <thead
                    class="border-b bg-neutral-50 font-medium dark:border-neutral-500 dark:text-neutral-800">
                    <tr>
                      <th scope="col" class=" px-6 py-4">Size</th>
                      <th scope="col" class=" px-6 py-4">Chiều cao(cm)</th>
                      <th scope="col" class=" px-6 py-4">Cân nặng(kg)</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">M</td>
                      <td class="whitespace-nowrap  px-6 py-4">160 - 168</td>
                      <td class="whitespace-nowrap  px-6 py-4">50 - 62</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">L</td>
                      <td class="whitespace-nowrap  px-6 py-4">169 - 173</td>
                      <td class="whitespace-nowrap  px-6 py-4">63 - 68</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XL</td>
                      <td class="whitespace-nowrap  px-6 py-4">171 - 174</td>
                      <td class="whitespace-nowrap  px-6 py-4">68 - 73</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XXL</td>
                      <td class="whitespace-nowrap  px-6 py-4">173 - 177</td>
                      <td class="whitespace-nowrap  px-6 py-4">74 - 80</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XXXL</td>
                      <td class="whitespace-nowrap  px-6 py-4">175 - 180</td>
                      <td class="whitespace-nowrap  px-6 py-4">81 - 90</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">28</td>
                      <td class="whitespace-nowrap  px-6 py-4">160 - 164</td>
                      <td class="whitespace-nowrap  px-6 py-4">50 - 55</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">29</td>
                      <td class="whitespace-nowrap  px-6 py-4">165 - 168</td>
                      <td class="whitespace-nowrap  px-6 py-4">56 - 62</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">30</td>
                      <td class="whitespace-nowrap  px-6 py-4">169 - 171</td>
                      <td class="whitespace-nowrap  px-6 py-4">63 - 65</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">31</td>
                      <td class="whitespace-nowrap  px-6 py-4">172 - 173</td>
                      <td class="whitespace-nowrap  px-6 py-4">66 - 73</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">32</td>
                      <td class="whitespace-nowrap  px-6 py-4">174 - 175</td>
                      <td class="whitespace-nowrap  px-6 py-4">74 - 77</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">34</td>
                      <td class="whitespace-nowrap  px-6 py-4">176 - 177</td>
                      <td class="whitespace-nowrap  px-6 py-4">78 - 80</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">36</td>
                      <td class="whitespace-nowrap  px-6 py-4">178 - 183</td>
                      <td class="whitespace-nowrap  px-6 py-4">81 - 90</td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span >CHỌN SIZE CHO ÁO NỮ</span>
      <div className=' md:pl-10 xl:pl-20  pb-10'>
        <div class="flex flex-col max-w-2xl">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div class="overflow-hidden">
                <table class="min-w-full text-center text-sm font-light">
                  <thead
                    class="border-b bg-neutral-50 font-medium dark:border-neutral-500 dark:text-neutral-800">
                    <tr>
                      <th scope="col" class=" px-6 py-4">Size</th>
                      <th scope="col" class=" px-6 py-4">Chiều cao(cm)</th>
                      <th scope="col" class=" px-6 py-4">Cân nặng(kg)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">S</td>
                      <td class="whitespace-nowrap  px-6 py-4">150 - 155</td>
                      <td class="whitespace-nowrap  px-6 py-4">40 - 45</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">M</td>
                      <td class="whitespace-nowrap  px-6 py-4">155 - 160</td>
                      <td class="whitespace-nowrap  px-6 py-4">46 - 50</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">L</td>
                      <td class="whitespace-nowrap  px-6 py-4">160 - 165</td>
                      <td class="whitespace-nowrap  px-6 py-4">51 - 55</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XL</td>
                      <td class="whitespace-nowrap  px-6 py-4">162 - 166</td>
                      <td class="whitespace-nowrap  px-6 py-4">56 - 60</td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span >CHỌN SIZE CHO QUẦN NỮ</span>
      <div className=' md:pl-10 xl:pl-20  pb-10'>
        <div class="flex flex-col max-w-2xl">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div class="overflow-hidden">
                <table class="min-w-full text-center text-sm font-light">
                  <thead
                    class="border-b bg-neutral-50 font-medium dark:border-neutral-500 dark:text-neutral-800">
                    <tr>
                      <th scope="col" class=" px-6 py-4">Size</th>
                      <th scope="col" class=" px-6 py-4">Chiều cao(cm)</th>
                      <th scope="col" class=" px-6 py-4">Cân nặng(kg)</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">S</td>
                      <td class="whitespace-nowrap  px-6 py-4">150 - 155</td>
                      <td class="whitespace-nowrap  px-6 py-4">40 - 45</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">M</td>
                      <td class="whitespace-nowrap  px-6 py-4">155 - 160</td>
                      <td class="whitespace-nowrap  px-6 py-4">46 - 50</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">L</td>
                      <td class="whitespace-nowrap  px-6 py-4">161 - 165</td>
                      <td class="whitespace-nowrap  px-6 py-4">51 - 55</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">XL</td>
                      <td class="whitespace-nowrap  px-6 py-4">162 - 166</td>
                      <td class="whitespace-nowrap  px-6 py-4">56 - 60</td>
                    </tr>
                    
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">25</td>
                      <td class="whitespace-nowrap  px-6 py-4">150 - 153</td>
                      <td class="whitespace-nowrap  px-6 py-4">40 - 43</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">26</td>
                      <td class="whitespace-nowrap  px-6 py-4">154 - 157</td>
                      <td class="whitespace-nowrap  px-6 py-4">44 - 47</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">27</td>
                      <td class="whitespace-nowrap  px-6 py-4">158 - 161</td>
                      <td class="whitespace-nowrap  px-6 py-4">48 - 51</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">28</td>
                      <td class="whitespace-nowrap  px-6 py-4">162 - 165</td>
                      <td class="whitespace-nowrap  px-6 py-4">52 - 55</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">29</td>
                      <td class="whitespace-nowrap  px-6 py-4">166 - 169</td>
                      <td class="whitespace-nowrap  px-6 py-4">56 - 59</td>
                    </tr>
                    <tr class="border-b dark:border-neutral-500">
                      <td class="whitespace-nowrap  px-6 py-4 font-medium">30</td>
                      <td class="whitespace-nowrap  px-6 py-4">170 - 175</td>
                      <td class="whitespace-nowrap  px-6 py-4">60 - 65</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  )
}
